import React from "react";

import { Button } from "src/app/components/Button/Button";
import IDHFormattedMessage from "src/app/components/IDHFormattedMessage/IDHFormattedMessage";
import TypeIcon from "../../../components/ExportTypes/TypeIcon";

export default function DownloadInXLSXButton({ exportList }) {
  return (
    <Button
      size="medium"
      variant="white"
      onClick={() => exportList("xls")}
      data-export-type="xls"
      data-qa="download-in-xls-button"
    >
      <TypeIcon type="xls" />
      <IDHFormattedMessage
        id="front_download_in"
        defaultMessage="Download in"
      />
      .XLSX
    </Button>
  );
}
